import { EnvironmentProviders } from '@angular/core';
import { providePrimeNG } from 'primeng/config';
import  BDSPreset from './bds-presets';

export function provideBDSTheme(): EnvironmentProviders {
  return providePrimeNG({
    theme: {
      preset: BDSPreset,
      options: {
        darkModeSelector: '.my-app-dark'
      }
    },
  });
}
